import { Map } from 'immutable';

const defaultLocale = 'en-US';

const localeMapping = Map({
  at: 'de-AT',
  au: 'en-AU',
  be: 'fr-BE',
  'be-fr': 'fr-BE',
  'be-nl': 'nl-BE',
  ca: 'en-CA',
  'ca-en': 'en-CA',
  'ca-fr': 'fr-CA',
  de: 'de-DE',
  dk: 'da-DK',
  ee: 'et-EE',
  es: 'es-ES',
  fi: 'fi-FI',
  'fi-fi': 'fi-FI',
  'fi-se': 'se-FI',
  fr: 'fr-FR',
  ie: 'en-IE',
  it: 'it-IT',
  li: 'lt-LT',
  'lu-de': 'de-LU',
  'lu-fr': 'fr-LU',
  lv: 'lv-LV',
  mx: 'es-MX',
  nl: 'nl-NL',
  no: 'no-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  ru: 'ru-RU',
  se: 'sv-SE',
  uk: 'en-UK',
  us: 'en-US',
});

const mapToLocale = (fromLocale: string): string => {
  const locale = localeMapping.get(fromLocale);

  if (locale === undefined) {
    if (localeMapping.includes(fromLocale)) {
      return fromLocale;
    }
    return defaultLocale;
  } else {
    return locale;
  }
};

export const getLanguageFromLocale = (locale?: string): string | undefined => {
  if (!locale) {
    return locale;
  }

  const indexOfHyphen = locale.indexOf('-');

  if (indexOfHyphen > -1) {
    return locale.substr(0, indexOfHyphen);
  } else {
    return locale;
  }
};

const getCountryFromLocale = (locale?: string): string | undefined => {
  if (!locale) {
    return locale;
  }

  const [, country] = locale.split('-');

  if (country) {
    return country;
  }

  return locale;
};

const getPrivacyNoticeCode = (country: string): string => {
  switch (country) {
    case 'AT':
      return 'at';
    case 'BE':
      return 'be-fr';
    case 'DK':
      return 'dk';
    case 'EE':
      return 'ee';
    case 'FI':
      return 'fi';
    case 'FR':
      return 'fr';
    case 'DE':
      return 'de';
    case 'HU':
      return 'hu';
    case 'LV':
      return 'lv';
    case 'LT':
      return 'lt';
    case 'NL':
      return 'nl';
    case 'NO':
      return 'no';
    case 'PL':
      return 'pl';
    case 'ES':
      return 'es';
    case 'SE':
      return 'se';
    case 'CH':
      return 'ch-de';
    case 'GB':
      return 'uk';
    case 'JP':
      return 'jp';
    default:
      return 'int';
  }
};

const LocaleMapper = {
  mapToLocale,
  getLanguageFromLocale,
  getCountryFromLocale,
  getPrivacyNoticeCode,
};

export default LocaleMapper;
